import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private readonly MONTHS_IN_QUARTER: number = 3;


  getCurrentDate(): Date {
    return new Date();
  }

  getCurrentQuarter(): number {
    return this.getQuarter(this.getCurrentDate());
  }

  getQuarter(date: Date): number {
    return Math.floor((date.getMonth() + this.MONTHS_IN_QUARTER) / this.MONTHS_IN_QUARTER);
  }

  getCurrentFullYear(): number {
    return this.getCurrentDate().getFullYear();
  }
}
